import { apiClient } from "@/services/api/axiosClient";
import type { ApiResponse } from "@/services/api/api.types";
import { API_ENDPOINTS } from "@/services/api/endpoints";

export const appSettingsService = {
  async deleteAccount(payload?: { reason?: string }): Promise<ApiResponse<unknown>> {
    const { data } = await apiClient.post<ApiResponse<unknown>>(
      API_ENDPOINTS.USER.DELETE_ACCOUNT,
      payload ?? {}
    );
    console.log("deleteAccount response", data);
    return data;
  },
};
